// 葡萄牙语
export default {
    login_module: {
        Login: 'Login',
        Register: 'Registro',
        noAccount: 'Ainda não tem uma conta?',
        hasAccount: 'Já tem uma conta?',
        loginSuccess:'Login realizado com sucesso!',
        IAgree: 'Eu concordo com',
        rememberMe: 'Lembrar de mim',
        lostPassword: 'Esqueci a senha',
        send: 'Enviar',
        userName: 'Nome de usuário',
        mailAddress: 'Endereço de email',
        pwdFormat: 'A senha deve conter de 6 a 18 dígitos e letras.',
        pwdConfirmFormat: 'Não é a mesma senha inserida nos dois campos.',
        pasConfirm: 'Confirmação da senha',
        pleaseInput: 'Por favor, insira',
        name: 'Nome',
        inputName: 'Por favor, insira seu nome',
        userNameFormat: 'O nome de usuário pode conter apenas caracteres alfanuméricos ou hífens únicos e não pode começar ou terminar com um hífen.',
        password: 'Senha',
        email: 'E-mail',
        inputEmail: 'Por favor, insira o e-mail',
        emailFormatError: 'Erro de formato de e-mail',
        enterEmail: 'Digite seu e-mail abaixo e enviaremos instruções de redefinição.',
        selectCountry: 'Selecione o país ',
        verificationCode: 'Código de verificação',
        verificationFormat: 'O código de verificação está incorreto.',
        CountryRegion: 'País/Região',
        inputPwd: 'Por favor insira a senha',
        activationPrompt: 'Enviaremos um e-mail de ativação para o seu e-mail. Ative-o em seu e-mail antes de fazer login.'
    },
    overview_module: {
        //overview
        today: 'Hoje',
        detectionQuantity: 'Quantidade de detecção',
        abnormalQuantity: 'Quantidade anormal',
        dailyDetection: 'Detecção diária',
        detectionItems: 'Detectar itens',
        bloodSugar: 'Glicose no sangue',
        bloodKetones: 'Cetonas no sangue',
        uricAcid: 'Ácido úrico',
        lactate: 'Lactato',
        mailbox: 'E-mail',
        detectionTime: 'Tempo de detecção',
        detectionValue: 'Valor de detecção',
        unit: 'Unidade',
        search: 'Procurar',
        enterName: 'Insira o nome',
        gender: 'Gênero',
        male: 'Masculino',
        female: 'Feminino',
        date: 'Data',
        //时段
        allGlucose: 'Toda a glicemia',
        midnight: 'Meia-noite',
        earlyMorning: 'De manhã cedo',
        afterBreakfast: 'Depois do café da manhã',
        beforeLunch: 'Antes do almoço',
        afterLunch: 'Depois do almoço',
        beforeDinner: 'Antes do jantar',
        afterDinner: 'Depois do jantar',
        bedtime: 'Hora de dormir'
    },
    table: {
        all: 'Todos',
        display: 'Mostrar',
        records: 'Registros',
        unused: 'Não utilizado',
        used: 'Usado'
    },
    aside: {
        //侧边栏
        overview: 'Visão geral',
        myPatients: 'Meus pacientes',
        personalInfo: 'Informações pessoais',
        allPatients: 'Todos os pacientes',
        inviteCodes: 'Códigos de convite',
        code: 'Códigos de convite',
        changePwd: 'Alterar a senha',
        allDoctors: 'Todos os médicos',
        allAgent: 'Todos agentes',
        allInviteCodes: 'Todos os códigos de convite',
        operations: 'Operações',
        feedback: 'Opinião',
        software: 'Software'
    },
    footer: {
        service: 'Privacidade e termos de serviço',
        support: 'Obtenha suporte'
    },
    patient_module: {
        //patient
        remind: 'Lembrar',
        sendMsg: 'Enviar mensagem',
        DMType: 'Tipo DM',
        lastUploadTime: 'Última hora de upload',
        device: 'Dispositivo',
        lastMeasureTime: 'Último tempo de detecção',
        country: 'País',
        type1: 'Tipo I',
        type2: 'Tipo II',
        otherForms: 'Outras formas',
        GDM: 'Tipo gestacional',
        typePre: 'Pré-diabetes',
        typeSpecial: 'Tipo especial'
    },
    patient_detail_module: {
        confirmationTime: 'Tempo de DM',
        addNote: 'Adicione uma nota',
        enterNote: 'Insira as informações da nota',
        editNote: 'Nota do editor',
        confirmDeleteNote: 'Certeza em deletar a nota',
        unbind: 'Desvincular',
        table: 'Tabela',
        logbook: 'Livro de registro',
        trends: 'Tendências',
        period: 'Período',
        Days: 'Dias',
        other: 'Outras formas',
        AvgDailyRange: 'Média diária de leitura no intervalo',
        AvgDailyNo: 'Média diária do número de leituras do medidor',
        readingRange: 'Leituras no intervalo',
        avgBG: 'Média de glicose no sangue',
        DerivedFrom: 'Derivado de',
        BGMReadings: 'Leitura do medidor de glicose',
        weeks: 'Semanas',
        monday: 'Seg',
        tuesday: 'Ter',
        wednesday: 'Qua',
        thursday: 'Qui',
        friday: 'Sex',
        saturday: 'Sab',
        sunday: 'Dom',
        group: 'Grupo',
        range: 'Intervalo',
        avg: 'Média',
        min: 'Valor mínimo',
        max: 'Valor máximo',
        low: 'Baixo',
        normal: 'Normal',
        high: 'Alto',
        time:'vez|vezes',
        medicine: 'Medicamento',
        food: 'Comida',
        sport: 'Esporte',
        DMInfo: 'Informações sobre diabetes',
        height: 'Altura',
        weight: 'Peso',
        PreMealSugarCtrlTgt: 'Alvo de controle de açúcar pré-refeição',
        PostprandialSugarCtrlTgt: 'Alvo de controle de açúcar pós-prandial',
        info: 'Informação',
        useDevice: 'Dispositivo',
        associatedDoc: 'Médico associado',
        associatedAgent: 'Agente associado',
        lastLoginTime: 'Hora do último login',
        uploadMethod: 'Método de upload',
        addMethod: 'Como adicioná-lo',
        manualAddition: 'Adicione Manully',
        realTime: 'Medição real -Time',
        historical: 'Medição histórica',
        recordTime: 'Registro do horário ',
        dose: 'Dose',
        type: 'Tipo',
        calories: 'Calorias',
        carbs: 'Carboidratos',
        proteins: 'Proteínas',
        fats: 'Gorduras',
        strength: 'Força',
        duration: 'Duração',
        sendCustomerConfirm: 'Enviaremos o conteúdo diretamente para o cliente, por favor, confirme repetidamente.',
        selectExportedTime: 'Selecione o intervalo de tempo para exportação de dados ',
        from: 'de',
        to: 'para',
        DetectionStats: 'Estatísticas de detecção',
        addedToday: 'Adicionado hoje',
        addedWeek: 'Adicionado nesta semana',
        addedMonth: 'Adicionado este mês',
        remarksNoEmpty: 'Comentários não podem estar vazios',
        selectTableTime: 'Selecione o intervalo de tempo dos dados da tabela',
        startDate: 'Data de início',
        endDate: 'Data final',
        belowRange: 'Leituras abaixo do intervalo',
        inRange: 'Leituras no intervalo',
        aboveRange: 'Leituras acima do intervalo',
        pleaseSelectTimeRange: 'Por favor, selecione um intervalo de tempo!'
    },
    weekdays: {
        Sun: 'Dom',
        Mon: 'Seg',
        Tue: 'Ter',
        Wed: 'Qua',
        Thu: 'Qui',
        Fri: 'Sex',
        Sat: 'Sab'
    },
    info_module: {
        basicInfo: 'Informação básica',
        avatar: 'Avatar',
        birthday: 'Aniversário',
        chooseDate: 'Escolha a data',
        selfIntro: 'Auto introdução',
        PEIntro: 'Introdução à experiência profissional',
        oldPwd: 'Senha Antiga',
        newPwd: 'Nova Senha',
        inputOldPwd: 'Por favor, insira a senha antiga',
        inputNewPwd: 'Por favor, insira uma nova senha',
        inputPwdAgain: 'Por favor digite sua senha novamente'
    },
    invite_module: {
        add: 'Adicionar',
        Use: 'Usar',
        push:"Empurrar",
        pushMail: 'Caixa de e-mail Push',
        remarks: 'Observações',
        creationTime: 'Tempo de criação',
        phone:'Telemóvel',
        pushPhone: 'Empurre o celular',
        phoneInfo: 'Enviaremos um código de convite para o telefone. Por favor, avise o seu paciente',
        action: 'Ação',
        generateCode: 'Gerar código de convite',
        codeInfo: 'Enviaremos um e-mail com o código de ativação para o endereço de e-mail. Por favor, lembre seu paciente para verificar.'
    },
    system_module:{
        welcome:'Bem-vindo,@{name}!',
        welcomeMsg:'VivaGuard lhe fornecerá melhores ferramentas para gerenciar a glicose no sangue. Agora você pode fazer login na aplicação VivaGuard e começar a registrar sua glicose!',
        changePwd:'Alterar senha',
        changePwdFor:'Alterar senha para @{name}',
        pwdInfo:'A senha deve conter pelo menos um caractere e um número, e ter pelo menos 6 caracteres.',
        resend:'Reenviar',
        resendInfo:'Seu conta ainda não foi ativada. Enviaremos um e-mail com o código de ativação para o endereço de e-mail registrado.',
        actived:'Completar ativação?',
        toLogin:'Clique para fazer login!',
        resendSuccess:'Reenviado com sucesso!',
        resendFailed:'Reenviado com falha!',
    },
    operation: {
        promot: 'Comando',
        edit: 'Editar',
        save: 'Salvar',
        yes: 'Confirmar',
        delete: 'Excluir',
        saveSend: 'Salve e envie',
        rePush: 'Re-push',
        cancel: 'Cancelar',
        exit: 'Sair',
        confirmExit: 'Você tem certeza que quer sair?',
        confirmDelete: 'Confirmar a eliminação?',
        addSuccessed: 'Adicionado com sucesso!',
        editSuccessed: 'Actualizado com sucesso!',
        successfullyDelete: 'excluido com sucesso',
    },
    notification:{
        1000: 'Token expirado',
        1001: 'Token expirado',
        1002: 'Erro do sistema',
        1003: 'Erro de parâmetro!',
        1006: 'Erro de parâmetro!',
        1008: 'Enviaremos um e-mail com o código de ativação para o endereço de e-mail registrado. Por favor, verifique-o.',
        1026: 'Não envie novamente!!!',
        6000: 'Arquivo é muito grande!',
        100001: 'Conta já registrada!',
        100002: 'Endereço de e-mail ou senha incorretos.',
        100004: 'Conta não existe!',
        100005: 'Conta não está ativada!',
        100006: 'Falha ao enviar e-mail! A caixa de entrada foi ativada!',
        100007: 'Conta está bloqueada!',
        100008: 'Senha incorreta!',
        100011: 'Falha ao enviar e-mail, por favor tente novamente!',
        200000: 'Código de verificação inválido!'
    },
    back:"Voltar"
}


// WEBPACK FOOTER //
// ./src/i18n/lang/pt.js